
import { ChevronRight, Home } from "lucide-react";
import { Link } from "react-router-dom";

interface AdminBreadcrumbProps {
  currentPage: string;
  parentPath?: string;
  parentLabel?: string;
  children?: React.ReactNode;
}

export const AdminBreadcrumb = ({ 
  currentPage, 
  parentPath,
  parentLabel,
  children 
}: AdminBreadcrumbProps) => {
  return (
    <div className="flex flex-col space-y-4 mb-6">
      <div className="flex items-center space-x-2">
        <Link 
          to="/admin" 
          className="text-primary hover:text-primary/90 text-sm flex items-center"
        >
          <Home className="h-4 w-4 mr-1" />
          Admin Dashboard
        </Link>
        
        {parentPath && parentLabel && (
          <>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
            <Link 
              to={parentPath} 
              className="text-primary hover:text-primary/90 text-sm"
            >
              {parentLabel}
            </Link>
          </>
        )}
        
        <ChevronRight className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm font-medium">{currentPage}</span>
      </div>
      
      {children && (
        <div className="flex items-center justify-between">
          {children}
        </div>
      )}
    </div>
  );
};
